import { useState } from "react";
import { Check, Loader2, Pencil, Trash2, X } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

// Nom d'une catégorie déjà enregistrée : « Renommer » met à jour les opérations déjà classées et les mémorisations
const NomRenommable = ({ cat, genre, onRenomme, testId, protegee }) => {
  const [edition, setEdition] = useState(false);
  const [nom, setNom] = useState(cat.nom);
  const [envoi, setEnvoi] = useState(false);
  const valider = async () => {
    setEnvoi(true);
    try {
      const { data } = await api.post("/categories/renommer", { genre, ancien: cat.nom, nouveau: nom.trim() });
      toast.success(`Renommé en « ${nom.trim()} » · ${data.operations} opération(s) et ${data.memoires} mémorisation(s) mises à jour`);
      onRenomme(nom.trim());
      setEdition(false);
    } catch (e) { toast.error(errMsg(e)); } finally { setEnvoi(false); }
  };
  if (!edition) {
    return (
      <div className="flex items-center gap-1">
        <Input value={cat.nom} readOnly className="bg-slate-50" title={protegee ? "Sert au classement automatique : nom non modifiable" : undefined} data-testid={`${testId}-name`} />
        {!protegee && <Button variant="ghost" size="icon" onClick={() => { setNom(cat.nom); setEdition(true); }} title="Renommer partout" className="text-slate-500 hover:text-emerald-700" data-testid={`${testId}-rename`}><Pencil className="h-4 w-4" /></Button>}
      </div>
    );
  }
  return (
    <div className="flex items-center gap-1">
      <Input autoFocus value={nom} onChange={(e) => setNom(e.target.value)} maxLength={80} onKeyDown={(e) => { if (e.key === "Enter") { valider(); } if (e.key === "Escape") { setEdition(false); } }} data-testid={`${testId}-rename-input`} />
      <Button variant="ghost" size="icon" onClick={valider} disabled={envoi || !nom.trim() || nom.trim() === cat.nom} className="text-emerald-700" data-testid={`${testId}-rename-ok`}>{envoi ? <Loader2 className="h-4 w-4 animate-spin" /> : <Check className="h-4 w-4" />}</Button>
      <Button variant="ghost" size="icon" onClick={() => setEdition(false)} className="text-slate-400" data-testid={`${testId}-rename-cancel`}><X className="h-4 w-4" /></Button>
    </div>
  );
};

export const CategoryRow = ({ cat, idx, onChange, onRemove, prefix = "category", genre = "depense", protegee = false }) => (
  <div className="grid grid-cols-[1fr_auto] md:grid-cols-[320px_1fr_auto] gap-2 items-center" data-testid={`${prefix}-row-${idx}`}>
    {cat.existant
      ? <NomRenommable cat={cat} genre={genre} protegee={protegee} onRenomme={(nom) => onChange(idx, { ...cat, nom })} testId={`${prefix}-${idx}`} />
      : <Input value={cat.nom} onChange={(e) => onChange(idx, { ...cat, nom: e.target.value })} placeholder="Nom" data-testid={`${prefix}-name-${idx}`} />}
    <Input value={cat.mots} onChange={(e) => onChange(idx, { ...cat, mots: e.target.value })} placeholder="MOTS, CLÉS, SÉPARÉS PAR DES VIRGULES" className="col-span-2 row-start-2 md:col-span-1 md:row-start-auto font-mono text-xs" data-testid={`${prefix}-keywords-${idx}`} />
    <Button variant="ghost" size="icon" onClick={() => onRemove(idx)} className="col-start-2 row-start-1 md:col-start-auto md:row-start-auto text-slate-400 hover:text-red-600" data-testid={`${prefix}-remove-${idx}`}><Trash2 className="h-4 w-4" /></Button>
  </div>
);
